<template>
  <v-container py-0>
    <v-layout row wrap>
      <v-flex xs12 pa-2>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $tc('fields.typeSubscriptions.specification', 2) }}
            </v-toolbar-title>
            <v-spacer />
            <v-dialog v-model="dialog" scrollable width="1024" lazy>
              <template #activator="{ on }">
                <v-btn small flat v-on="on">
                  {{ $t('action.buttons.new') }}
                </v-btn>
              </template>
              <v-card>
                <v-toolbar flat dense color="primary" dark>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-btn dark icon @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 px-2>
                      <translation-field
                        ref="description"
                        v-model="editedItem.description"
                        :label="$t('fields.typeSubscriptions.description')"
                        required
                      />
                    </v-flex>
                    <v-flex md3 sm6 xs12 px-2>
                      <v-text-field
                        v-model.number="editedItem.order"
                        v-validate="'required|numeric'"
                        type="number"
                        :label="$t('fields.global.order') + ' *'"
                        :data-vv-name="$t('fields.global.order')"
                        :error-messages="
                          errors.collect($t('fields.global.order'))
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <template>
                    <span style="color: red">(*) &nbsp;</span>
                    <span>{{ $t('action.messages.fieldRequired') }}</span>
                  </template>
                  <v-spacer />
                  <!-- <meta-button @click="clear" type="reset" /> -->
                  <meta-button
                    :type="editedIndex === -1 ? 'add' : 'update'"
                    @click="save"
                  />
                  <meta-button type="cancel" @click="close" />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card-text class="pa-0">
            <div class="v-table__overflow">
              <table
                class="v-datatable v-table theme--light"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th>{{ $t('fields.global.actions') }}</th>
                    <th>{{ $t('fields.global.order') }}</th>
                    <th class="text-xs-left">
                      {{ $t('fields.typeSubscriptions.description') }}
                    </th>
                  </tr>
                </thead>
                <draggable
                  v-model="items"
                  tag="tbody"
                  :handle="isMobile && items.length > 1 ? '.handle' : ''"
                  :class="items.length > 1 ? 'draggable' : ''"
                  @end="dragEnd"
                >
                  <tr v-for="(item, index) in items" :key="index + 20">
                    <td class="justify-center layout px-0">
                      <v-icon
                        class="mr-2"
                        color="success"
                        @click="editItem(item)"
                      >
                        edit
                      </v-icon>
                      <v-icon color="error" @click="ifDeleteItem(index)">
                        delete
                      </v-icon>
                    </td>
                    <td class="text-xs-center">
                      {{ item.order }}
                    </td>
                    <td>
                      {{ getName(item.description) }}
                    </td>
                    <hr />
                  </tr>
                  <tr v-if="!items.length">
                    <td colspan="9" class="text-xs-center">
                      {{ $vuetify.t('$vuetify.noDataText') }}
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </v-card-text>
        </v-card>
        <dialog-delete
          :dialog.sync="dialogDelete"
          @delete="deleteItem(indexDelete)"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import TranslationField from '@/components/widgets/Input/TranslationField'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
export default {
  name: 'Specifications',
  components: {
    DialogDelete,
    draggable,
    TranslationField,
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    editedIndex: -1,
    editedItem: {
      order: '',
      description: [],
    },
    // defaultItem: {
    //   order: '',
    //   description: []
    // },
    dialogDelete: false,
  }),

  computed: {
    items: {
      get() {
        return Array.isArray(this.value) ? this.value : []
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formTitle() {
      return this.editedIndex !== -1
        ? this.$t('titles.global.updateModel', {
            field: this.$tc('fields.typeSubscriptions.specification'),
          })
        : this.$t('titles.global.newAModel', {
            field: this.$tc('fields.typeSubscriptions.specification'),
          })
    },
    defaultItem() {
      let nextOrder = 1
      this.items.forEach((item) => {
        if (item.order >= nextOrder) nextOrder = item.order + 1
      })
      return {
        order: nextOrder,
        description: [],
      }
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        if (this.editedIndex === -1)
          this.editedItem = Object.assign({}, this.defaultItem)
      } else this.close()
    },
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    ifDeleteItem(index) {
      this.indexDelete = index
      this.dialogDelete = true
    },
    deleteItem(indexDelete) {
      this.items.splice(indexDelete, 1)
      this.items.sort((a, b) => a.order - b.order)
      this.dragEnd()
      this.dialogDelete = false
      this.indexDelete = ''
    },
    dragEnd() {
      this.items = this.items.map((item, index) => ({
        ...item,
        order: index + 1,
      }))
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$validator.reset()
        this.$refs.description.$validator.reset()
      }, 300)
    },

    save() {
      Promise.all([this.validate(), this.$refs.description.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return
          if (this.editedIndex > -1) {
            Object.assign(this.items[this.editedIndex], this.editedItem)
          } else {
            this.items.push(this.editedItem)
          }
          this.close()
        }
      )
    },
  },
}
</script>
